import React, { Suspense } from 'react';
import { Layout } from 'antd';
import SiteHeader from '../components/header';
import ProfileMenu from '../components/profile/ProfileMenu';
import Can from '../services/permisions/Can'

const { Content } = Layout;

/* Profile Layout */
const ProfileLayout = ({ children, ...rest }) => {

    return (
        <Layout>
            <SiteHeader></SiteHeader>
            <Layout>
                <Layout>
                    <Content>
                        <div className="settings-block tb--pb-8">
                            <ProfileMenu />
                            <div className="settings--section-content">
                                {children}
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )
}

/*
  Private route wrapper for React Router v6
 */

export const ProfileLayoutRoute = ({ component: Component, permissions, ...rest }) => {
    return (
        <Can I={permissions.type} a={permissions.name} withRedirect={true}>
            <ProfileLayout>
                <Suspense fallback={<></>}>
                    <Component {...rest} />
                </Suspense>
            </ProfileLayout>
        </Can>
    );
};

